import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import Clock from 'shared/icons/clock.svg'
import Money from 'shared/icons/money.svg'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

export const ProsMplus = () => {
  const { t } = useTranslation()
  return (
    <div className={s.prosMplus}>
      <h4 className={clsx(s.title, 'semi-bold-20')}>{t('mplus.pros_mplus')}</h4>

      <div className={s.cards}>
        <div className={s.card}>
          <ImageLazy
            alt=""
            src={Money}
            className={s.icon}
          />

          <p className={clsx(s.description, 'medium-14')}>
            {t('mplus.pay_you_comfortable')}
          </p>
        </div>
        <div className={s.card}>
          <ImageLazy
            alt=""
            src={Clock}
            className={s.icon}
          />

          <p className={clsx(s.description, 'medium-14')}>
            {t('mplus.available_any_time')}
          </p>
        </div>
      </div>
    </div>
  )
}
